module.exports = __webpack_public_path__ + "static/media/Socialpiper-boostingpower-esp.0d843cb7.png";